import { Box, TableCell, TableRow } from '@material-ui/core';
import {
  AgentInSinglePaymentProviderContext,
  CardPaymentProviderName,
  formatDateTimeReadable,
} from '@nemuru-eng/js-api-client';

import { SinglePaymentProviderIds } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/constants/SinglePaymentMethodsProviderIds';
import { SinglePaymentProviderLogo } from '@/components/modules/Application/components/PaymentMethod/_shared/components/SinglePaymentProviderLogo';
import { ConditionalWrapper } from '@/components/shared/components/ConditionalWrapper';
import { MoreActionsMenu } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenu';
import { MoreActionsMenuWithIcon } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenuWithIcon';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';
import { DefaultTableProps } from '@/types/defaultTableProps';
import { findKeyByValue } from '@/utils/findKeyByValue';
interface AgentInSinglePaymentProviderContextRowProps {
  agentInSinglePaymentProviderContext: AgentInSinglePaymentProviderContext;
  handleEditCredentials: ({ agentCredentials }: { agentCredentials: AgentInSinglePaymentProviderContext }) => void;
  handleDeleteCredentials: ({ agentCredentials }: { agentCredentials: AgentInSinglePaymentProviderContext }) => void;
  tableProps: Omit<DefaultTableProps, 'isScrollable'>;
  hideColumnsForDeleteMode?: boolean;
  disabled?: boolean;
}
export const AgentInSinglePaymentProviderContextRow = ({
  agentInSinglePaymentProviderContext,
  handleEditCredentials,
  handleDeleteCredentials,
  tableProps,
  hideColumnsForDeleteMode,
  disabled = false,
}: AgentInSinglePaymentProviderContextRowProps) => {
  const { classes } = tableProps;
  const { isMobile } = useScreen();
  const { palette } = useCustomTheme();
  const actionsOptionsArrayByIndex = () => {
    return [
      {
        display: <Text tId={'EDIT_CREDENTIALS'} />,
        iconName: 'edit',
        onClick: () => handleEditCredentials({ agentCredentials: agentInSinglePaymentProviderContext }),
      },
      {
        display: <Text tId={'DELETE_CREDENTIALS'} />,
        iconName: 'delete',
        onClick: () => handleDeleteCredentials({ agentCredentials: agentInSinglePaymentProviderContext }),
      },
    ];
  };
  const providerName = findKeyByValue(SinglePaymentProviderIds, agentInSinglePaymentProviderContext.providerId);
  const desktopItemRow = (
    <TableRow
      key={agentInSinglePaymentProviderContext.agentId}
      className={classes.root}
      style={{
        backgroundColor: disabled ? palette.grey[50] : 'inherit',
        maxWidth: '100%',
      }}
    >
      <TableCell align={'center'}>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
          <Box style={{ filter: disabled ? 'grayscale(100%) opacity(30%)' : 'none' }}>
            {providerName ? <SinglePaymentProviderLogo providers={[providerName]} size={86} /> : '-'}
          </Box>
        </Box>
      </TableCell>
      <TableCell align={'left'}>
        <Box className={'overflow-text-ellipsis'} style={{ maxWidth: '280px' }}>
          <Font variant={'body2'} style={{ color: disabled ? palette.grey[400] : palette.text.primary }}>
            <Text tId={agentInSinglePaymentProviderContext.paymentMethodType} />
          </Font>
        </Box>
      </TableCell>
      <TableCell align={'left'}>
        <Box className={'shorted-cell simple-select overflow-text-ellipsis'} style={{ maxWidth: '130px' }}>
          <Font variant={'body2'} style={{ color: disabled ? palette.grey[400] : palette.text.primary }}>
            {agentInSinglePaymentProviderContext.providerId}
          </Font>
        </Box>
      </TableCell>
      {/* <TableCell align={'left'}>
        <Box className={'shorted-cell simple-select overflow-text-ellipsis'} style={{ maxWidth: '130px' }}>
          <Font variant={'body2'} style={{ color: disabled ? palette.grey[400] : palette.text.primary }}>
            {agentInSinglePaymentProviderContext.agentId || '-'}
          </Font>
        </Box>
      </TableCell> */}
      {!hideColumnsForDeleteMode && (
        <TableCell width={'140px'} align={'left'}>
          <Font variant={'body2'} style={{ color: disabled ? palette.grey[400] : palette.text.primary }}>
            {formatDateTimeReadable(agentInSinglePaymentProviderContext.createdAt)}
          </Font>
        </TableCell>
      )}
      {!hideColumnsForDeleteMode && (
        <TableCell align={'right'}>
          <MoreActionsMenuWithIcon actionsOptionsArray={actionsOptionsArrayByIndex()} />
        </TableCell>
      )}
    </TableRow>
  );
  const mobileItemRow = (
    <ConditionalWrapper
      condition={!hideColumnsForDeleteMode}
      wrapper={(children) => (
        <MoreActionsMenu
          actionsOptionsArray={actionsOptionsArrayByIndex()}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {children}
        </MoreActionsMenu>
      )}
    >
      <TableRow
        key={agentInSinglePaymentProviderContext.id}
        className={classes.root}
        style={{
          backgroundColor: disabled ? palette.grey[50] : 'inherit',
        }}
      >
        <TableCell align={'center'}>
          <Box p={1} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <SinglePaymentProviderLogo providers={[CardPaymentProviderName.COMERCIA]} size={86} /> {/*HARDCODED =>  */}
          </Box>
        </TableCell>
        <TableCell align={'left'}>
          <Box className={'overflow-text-ellipsis'} style={{ maxWidth: '280px' }}>
            <Font variant={'body2'} style={{ color: disabled ? palette.grey[400] : palette.text.primary }}>
              <Text tId={agentInSinglePaymentProviderContext.paymentMethodType} />
            </Font>
          </Box>
        </TableCell>
        <TableCell align={'left'}>
          <div>
            <div className={'shorted-cell simple-select overflow-text-ellipsis'} style={{ maxWidth: '130px' }}>
              <Font variant={'body2'} style={{ color: disabled ? palette.grey[400] : palette.text.primary }}>
                {agentInSinglePaymentProviderContext.providerId}
              </Font>
            </div>
          </div>
        </TableCell>
        {!hideColumnsForDeleteMode && (
          <TableCell align={'right'}>
            <MoreActionsMenuWithIcon actionsOptionsArray={actionsOptionsArrayByIndex()} />
          </TableCell>
        )}
      </TableRow>
    </ConditionalWrapper>
  );
  return !isMobile ? desktopItemRow : mobileItemRow;
};
